export const initialState = {
    isLoading: false,
    isLoadingFinish: false,
    loadingApis: [],
    isLoadingDepositPending: false,
    loadingForLead: false,
    loadingForClincheckLead: false,
    loadingForExport: false,
    archivedLoading: false,
    error: '',
    message: '',
    createLead: null,
    createLeadForConsent: {},
    newLeadDetail: {
        personalDetail: null
    },
    lead: {
        results: []
    },
    newDashLead: {
        results: []
    },
    newStatusLead: {
        results: []
    },
    consultantAttendStatusLead: {
        results: []
    },
    consultantClinCheckStatusLead: {
        results: []
    },
    attendedChecklistsStatusLead: {
        results: []
    },
    consultantBookedStatusLead: {
        results: []
    },
    failedToAttendStatusLead: {
        results: []
    },
    closedStatusLead: {
        results: []
    },
    treatmentStartedStatusLead: {
        results: []
    },
    consentLink: null,
    followLead: null,
    isAppointmentBooked: null,
    searchedLead: null,
    universalSearchResults: null,
    attendance: null,
    BookingAttendance: null,
    leadDetail: null,
    leadDetailNotFound: false,
    tableRowLead: null,
    archivedLead: null,
    leadNotes: null,
    leadNotesWithFilter: null,
    leadReminder: null,
    leadFlowReminder: {
        results: [],
        count: 0,
    },
    activeTab: 0,
    followUpLead: null,
    markAsComplete: false,
    allReminders: null,
    taskPageData: null,
    contactLead: true,
    // Populated when a note with contacted_via is added and the contacted
    // count crosses a table threshold (0→1, 1→2, 2→3+).  Consumed by a
    // UI component to fire an iOS toast, then immediately cleared.
    followUpTableMoved: null,
    archivedList: [],
    appointmentNotes: '',
    taskTableData: {
        limit: 10,
        offset: 0,
        filter: '',
        assignUser: '',
        tasks: {
            limit: 10,
            offset: 0,
            filter: '',
            assignUser: '',
        }
    },
    taskLaneCounts: null,
    isAssigned: false,
    upComingData: null,
    isLeadArchived: false,
    paymentComplete: [],
    checkoutListing: [],
    leadSummaryListing: [],
    leadNotesArr: null,
    leadStatusSummaryListing: [],
    autoMatedMessages: [],
    dashNewContact: {
        count: '0',
        labelCounter: 0,
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'NEW',
        tag: [],
        filterTags: [],
        referral: '',
        assignee: []
    },
    dashNewContactForWidget: {
        date: [],
    },
    dashContact: {
        count: 'All',
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'All',
        tag: [],
        filterTags: [],
        referral: '',
        assignee: []
    },
    alignerTable: {
        count: 'All',
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'All',
        tag: [],
        filterTags: [],
        referral: '',
        assignee: [],
        bookedWith: [],
    },
    noTaskTableData: {
        count: 'All',
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'All',
        tag: [],
        filterTags: [],
        referral: '',
        assignee: [],
        leadStatus: [],
        contactedCountFilter: ''
    },
    newContact: {
        count: '0',
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'NEW',
        tag: [],
        filterTags: [],
        referral: '',
        assignee: []
    },
    attendContact: {
        count: 'All',
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'CONSULTATION_ATTENDED',
        tag: [],
        filterTags: [],
        referral: '',
        bookedWith: [],
        depositPendingStatus: '',
        assignee: [],
        contactedCountFilter: '',
        // Persists the In Progress / Follow-Up Complete sub-strip selection when a
        // custom tab with checklist_binding is active on the consultant-attended table
        // (e.g. the Invisalign tab on practice 92). Mirrors attendedChecklistsContact.
        checklistState: 'in_progress',
    },
    clincheckContact: {
        count: '0',
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'CONSULTATION_ATTENDED',
        tag: [],
        filterTags: [],
        referral: '',
        bookedWith: [],
        depositPendingStatus: '',
        assignee: []
    },
    attendedChecklistsContact: {
        count: 'in_progress',
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'CONSULTATION_ATTENDED',
        tag: [],
        filterTags: [],
        referral: '',
        bookedWith: [],
        depositPendingStatus: '',
        assignee: [],
        checklistState: 'in_progress'
    },
    bookedContact: {
        count: 'All',
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'CONSULTATION_BOOKED',
        tag: [],
        filterTags: [],
        referral: '',
        bookedWith: [],
        depositPendingStatus: '',
        assignee: []
    },
    failedToAttendContact: {
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'FAILED_TO_ATTEND_CONSULTATION',
        tag: [],
        filterTags: [],
        referral: '',
        assignee: []
    },
    closedContact: {
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'CLOSED',
        tag: [],
        filterTags: [],
        referral: '',
        assignee: []
    },
    treatmentStarted: {
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'created_at',
        search: '',
        treatment: [],
        date: [],
        status: 'TREATMENT_STARTED',
        tag: [],
        filterTags: [],
        referral: '',
        category: '0',
        categoryName: '',
        bookedWith: [],
        consultationBookedWith: [],
        apptType: '',
        assignee: [],
        // Persists the In Progress / Follow-Up Complete sub-strip selection when a
        // custom tab with checklist_binding is active on the treatment-started table.
        // Mirrors attendedChecklistsContact and attendContact.
        checklistState: 'in_progress',
    },
    archivedContact: {
        pageNumber: 0,
        perPage: 10,
        order: 'desc',
        orderValue: 'archive_at',
        search: '',
        treatment: [],
        date: [],
        status: 'archive',
        tag: [],
        filterTags: [],
        referral: '',
        assignee: [],
        archiveReason: ''
    },
    leadTaskCounter: 0,
    leadTaskTab: '',
    counter: [],
    taskCounter: [],
    taskLeadCounter: [],
    taskFlowCounter: [],
    separateTaskCounter: [],
    taskSearchLead: null,
    archiveLeadTags: [],
    contactedLead: null,
    leadTreatmentsListing: {
        results: []
    },
    dashboardTaskPageFilter: 'Today',
    leadDetailTaskPageFilter: 'Today',
    taskPageFilter: 'Today',
    taskDetail: {},
    isTasksCompleted: false,
    dateFormat: (localStorage.getItem('dateFormat') || 'date_time_format'),
    dateArchiveFormat: (localStorage.getItem('dateArchiveFormat') || 'date_time_format'),
    dateAppointmentFormat: (localStorage.getItem('appointmentFormat') || 'date_time_format'),
    consultationDateFormat: (localStorage.getItem('consultationDateFormat') || 'date_time_format'),
    dateLastContactFormat: (localStorage.getItem('lastContactFormat') || 'date_time_format'),
    dateAttendedFormat: (localStorage.getItem('attendedFormat') || 'date_time_format'),
    multiLead: {
        leadId: [],
        type: '',
        loading: false
    },
    tableType: '',
    duplicateMultiLead: {
        leadId: [],
        type: '',
        loading: false
    },
    mergeTags: (localStorage.getItem('MergeTagsData') && JSON.parse(localStorage.getItem('MergeTagsData')) || []),
    pageDetail: {},
    currentTreatmentData: null,
    attendedActiveTab: '',
    treatmentDepositStatus: false,
    treatmentLoading: false,
    todoListFilter: '',
    chatbotConversation: null,
    appointmentDateValue: null,
    action: null,
    unassignedUser: false,
    appointmentUserValue: null,
    sendReminderDuringLeadCreate: false,
    existingAudienceLeadList: {
        results: [],
        count: 0
    },
    // Dentally booking flow state
    isDentallyBooking: false,
    dentallySlot: null,
    dentallyPatientId: null,
    pendingDentallySync: null,
};
